import React from "react";

interface ButtonProps {
	onClick?: () => void;
	title?: string;
	className?: string;
	variant?: "primary" | "secondary";
	isDisabled?: boolean;
	isLoading?: boolean;
	icon?: any;
	type?: "submit" | "reset" | "button";
	iconPosition?: "left" | "right";
}

const CustomButton: React.FC<ButtonProps> = ({
	onClick,
	title,
	className = "",
	variant = "primary",
	isDisabled = false,
	isLoading,
	type = "button",
	icon,
	iconPosition = "right",
}) => {
	const baseStyles =
		"px-6 py-2 rounded-md font-semibold transition-all duration-200 flex items-center justify-center gap-2 transform";

	const variantStyles = {
		primary:
			"bg-primary text-white hover:bg-primary/85 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50",
		secondary:
			"bg-black text-white hover:bg-primary/75 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50",
		default:
			"bg-white text-gray-800 border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500",
	};

	return (
		<button
			type={type}
			disabled={isDisabled || isLoading}
			onClick={onClick}
			className={`${baseStyles} ${variantStyles[variant]} ${className} 
        ${
					!isDisabled && !isLoading
						? "hover:scale-105 hover:shadow-lg"
						: "opacity-50 cursor-not-allowed"
				}`}
		>
			{isLoading ? (
				<>
					<span>Loading...</span>
				</>
			) : (
				<>
					{icon && iconPosition === "left" && (
						<span className="mr-2">
							<img src={icon} alt="icon" width={16} height={16} />
						</span>
					)}
					{title && <span>{title}</span>}
					{icon && iconPosition === "right" && (
						<span className="ml-2">
							<img src={icon} alt="icon" width={16} height={16} />
						</span>
					)}
				</>
			)}
		</button>
	);
};

export default CustomButton;
